import { queryOptions } from '@tanstack/react-query'

import { STREAM_STALE_TIME } from '@/shared/config'

import { fetchNotifications, fetchUnreadCount } from './notifications-api'
import { notificationKeys } from './query-keys'

/** The popover is the whole feature — there is no page behind it to page through. */
export const NOTIFICATIONS_BELL_LIMIT = 20

/*
 * Both are stream-fed: `NotificationsBell` invalidates this whole tree on
 * `notifications.new` and again on reconnect, so the freshness of these queries
 * is decided by the socket and not by a clock. `staleTime: Infinity` says that
 * — it does not mean "never refetch", because invalidation marks a query stale
 * regardless. What it removes is the refetch on mount and on window focus,
 * which is polling laid on top of a push channel.
 */
export const notificationsBellQuery = () =>
  queryOptions({
    queryKey: notificationKeys.bell(),
    staleTime: STREAM_STALE_TIME,
    queryFn: ({ signal }) =>
      fetchNotifications({ limit: NOTIFICATIONS_BELL_LIMIT, offset: 0 }, signal),
  })

export const unreadCountQuery = () =>
  queryOptions({
    queryKey: notificationKeys.unread(),
    staleTime: STREAM_STALE_TIME,
    queryFn: ({ signal }) => fetchUnreadCount(signal),
  })
